/**
 * AddressAutoCompelete
 * 
 * @Author: Focci
 * @Date: 2025-02-08 15:19:07
 * @Last Modified by: Focci
 * @Last Modified time: 2025-02-08 15:19:07
 */

'use client'

// import PropTypes from 'prop-types'
import { useCallback } from 'react'
import { houseSearchType } from '@lib/config'
import { useTranslations } from 'next-intl'
import CombineAutocomplete from '@comp/page/common/filter/combine/CombineAutocomplete'

export default function AddressAutoCompelete({ form }) {
  const te = useTranslations('enquiry')

  const handleChange = useCallback((_e, v) => {
    form.setValue('address', v?.label || '')
  }, [form])

  const handleKeywordChange = useCallback((v) => {
    // 清空keyword时，会返回 undefined, 判断为了兼容
    v && form.setValue('address', v)
  }, [form])

  return (
    <CombineAutocomplete
      freeSolo
      value={form.getValues('address')}
      type={houseSearchType.estimate}
      multiple={false}
      wraperClassName="rounded-lg !min-h-[43.5px]"
      onChange={handleChange}
      onKeywordChange={handleKeywordChange}
      placeholder={te('addrOfAppraised')}
    />
  )
}

// AddressAutoCompelete.propTypes = {
//   className: PropTypes.string,
// }
